



























































































































import { Vue, Component } from 'vue-property-decorator';
import {
  FmvSidebar,
  FmvSidebarMenu,
} from 'fmv-layout';
import {FmvAvatar} from 'fmv-avatar';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';
import {elementScrollIntoView} from 'seamless-scroll-polyfill';
import {dispatchGetMainMenu, dispatchUserLogOut} from '@/store/main/actions';
import {readMainMenu, readUserProfile} from '@/store/main/getters';

@Component({
  components: {
    FmvAvatar,
    MdIcon,
    FmvSidebar,
    FmvSidebarMenu,
  },
})
export default class Sidebar extends Vue {
  public sidebarType = 'light';
  public sidebarVariant = null;
  public sidebarBrand = 'unifordi';
  public brandImage = '/';
  public sidebarBrandClass = null;
  public sidebarSearch = true;
  public sidebarSearchFormClass = null;
  public sidebarMenu = true;
  public sidebarMenuName = 'unifordi';
  public scrollIntoViewElement = 'scrollIntoView';

  public scrollIntoView() {
    this.$nextTick(() => {
      const target = document.querySelector(`#${this.scrollIntoViewElement}`);
      if (target) {
        elementScrollIntoView(target, {
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });
      }
    });
  }

  public toggleSidebar() {
    const sidebar = document.getElementById('default-drawer');
    // @ts-ignore
    if (sidebar.getAttribute('data-opened')) {
      // @ts-ignore
      sidebar.removeAttribute('data-opened');
    }
  }

  public async mounted() {
    await dispatchGetMainMenu(this.$store);
  }

  get mainMenu() {
    return readMainMenu(this.$store);
  }

  public async handleOpenExternalLink(url) {
    if (url !== '') {
      window.open(url, '_blank');
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public copyPromo() {
    const testingCodeToCopy = document.querySelector('#promo-input-sidebar');
    // @ts-ignore
    testingCodeToCopy.setAttribute('type', 'text');
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      const range = document.createRange();
      // @ts-ignore
      range.selectNode(testingCodeToCopy);
      const selection = window.getSelection();
      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    } else {
      // @ts-ignore
      testingCodeToCopy.select();
    }


    try {
      const successful = document.execCommand('copy');
      // @ts-ignore
      this.$noty.error(this.$t('Link copied'));
    } catch (err) {
      // @ts-ignore
      this.$noty.error(this.$t('Copy error'));
    }
    // @ts-ignore
    testingCodeToCopy.setAttribute('type', 'hidden');
    // @ts-ignore
    window.getSelection().removeAllRanges();
  }
  public async logout() {
    await dispatchUserLogOut(this.$store);
  }
}
